module.exports = __webpack_public_path__ + "img/26.46e799ff.png";